import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Modal from 'react-modal'

import { Button } from '../Button/Button'
import { getIsModalShown, getIsVolumeOn, toggleVolume, toggleModal } from '../../store/commonSlice'
import { goNextScreen } from '../../store/screenSlice'

import styles from './SettingsModal.module.scss'
import volumeOn from './volumeOn.png'
import volumeOff from './volumeOff.png'
import restart from './restart.png'


function SettingsModalBody({ isVisible, isVolumeOn, goNextScreen, toggleVolume, toggleModal }) {
    return (
        <Modal
            isOpen={isVisible}
            overlayClassName={styles.overlay}
            className={styles.modal}
            onRequestClose={() => { toggleModal() }}
        >
            <Button
                isNeedRegisterResource={false}
                src={isVolumeOn ? volumeOn : volumeOff}
                onClick={() => { toggleVolume() }}
                className={styles.modalButton}
            />
            <Button
                isNeedRegisterResource={false}
                src={restart}
                onClick={() => {
                    toggleModal()
                    goNextScreen({ restart: true })
                }}
                className={styles.modalButton}
            />
        </Modal>
    )
}

SettingsModalBody.propTypes = {
    isVisible: PropTypes.bool.isRequired,
    isVolumeOn: PropTypes.bool.isRequired,
    goNextScreen: PropTypes.func.isRequired,
    toggleVolume: PropTypes.func.isRequired,
    toggleModal: PropTypes.func.isRequired,
}

const SettingsModal = connect(
    state => ({
        isVisible: getIsModalShown(state),
        isVolumeOn: getIsVolumeOn(state),
    }), {
        goNextScreen,
        toggleVolume,
        toggleModal,
    },
)(SettingsModalBody)

SettingsModal.propTypes = {}

export { SettingsModal }
